module.exports = __webpack_public_path__ + "img/v2_3.e63dd918.png";